export default __webpack_public_path__ + "images/c1f8215453080fa428921703daf2a47b.png";